import axios from 'axios';
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import React, { useState, useEffect } from 'react';
import Calaneder from "../../assets/svg/desk.svg";
import UserDefaultLogo from '../UserDetails/UserDefaultLogo';
import { CustomImageModal, CustomImageModalTrial1, handleErrorToast } from '../CustomFunctions';
import Loader from "../Loader";
import { AddEmployeeIcon, Calender, Employee, UserProfileIcon } from '../AllSvg';


// Job Openings
const Newemployee = () => {
    const [newEmployee, setNewEmployee] = useState([]);

    const getNewEmployee = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/attandance/jobopening/`);
            setNewEmployee(res.data);
        } catch (err) {
            // IMPORTANT: TURN THE BELOW COMMENT OFF!!!
            // alert(err.message);
            // handleErrorToast(err)
        }
    };
    useEffect(() => {
        getNewEmployee();
    }, []);

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };


    return (
        <div className="dashcomp-bg-cards" >

            {newEmployee.map((data, index) => {
                const formattedDate = new Date(data.date).toLocaleString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric',
                });
                return (
                    <>
                        <div className="EmployeeDashboad-notification-card">
                            <h3 className='dashcomp-announcement-heading font-weight500    font-size-subheading  '>{index + 1}.{"  "}{data.title}</h3>
                            <span className="dashcomp-announcement-date  font-weight500   font-size-subheading  ">
                                {/* <img src={} alt="Desk Icon"
                          style={{ color: 'red', marginRight: '8px',
                          width: '16px', height: '16px', marginTop: "-4px" }}
                      /> */}
                                {formattedDate}
                            </span>
                            <p className="dashcomp-announcement-p font-weight400  font-size-text">
                                <div dangerouslySetInnerHTML={createMarkup(data.description)} />
                            </p>
                        </div>
                    </>
                )
            })
            }
        </div>
    )
}


// Main Component
const NewEmployee = () => {

    const [anniversary, setAnniversary] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    // const [selectedImage, setSelectedImage] = useState('');

    const getBirthdayData = async () => {
        setBuffering(true); // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/wfm/joinies/`);
            setAnniversary(res.data);
        } catch (err) {
            console.error(err.message);
            // handleErrorToast(err)
        } finally {
            setBuffering(false);// End Buffering
        }
    };

    useEffect(() => {
        getBirthdayData();
    }, []);

    const visibleCount = 2;
    const totalPages = Math.ceil(anniversary.length / visibleCount);
    const maxDots = 2;

    const handlePrev = () => setCurrentIndex(i => Math.max(0, i - 1));
    const handleNext = () => setCurrentIndex(i => Math.min(totalPages - 1, i + 1));

    const visibleEmployees = anniversary
        .sort((a, b) => new Date(b.joining_date) - new Date(a.joining_date))
        .slice(currentIndex * visibleCount, currentIndex * visibleCount + visibleCount);

    // max 2 dots logic
    const getDotsConfig = () => {
        if (totalPages <= maxDots) {
            return Array.from({ length: totalPages }, (_, i) => i);
        }
        // sliding window of 2 dots
        if (currentIndex === 0) return [0, 1];
        if (currentIndex >= totalPages - 1) return [totalPages - 2, totalPages - 1];
        return [currentIndex - 1, currentIndex];
    };


    // return (
    //     <div className='backgroundmain dashboard-card-emp' >
    //         <div className='dashboardcomponent box-width'>
    //             <div className="task-heading">
    //                 <div className='task-sub-heading  font-weight400  font-size-subheading  '>New Joining Employees</div>
    //                 {Newemployee}
    //             </div>
    //             <div className='task-hr' style={{ marginBottom: '0px' }}></div>
    //             {
    //                 buffer ?
    //                     <Loader container={true} />
    //                     :
    //                     <div className='birthdaywrap EmployeeDashboad-notification-cards d-flex-wrap' style={{ height: '284px' }} >
    //                         {anniversary
    //                             // .filter(data => data.division === sessionStorage.getItem('company_id'))
    //                             // .sort((a, b) => Date(b.joining_date) - Date(a.joining_date))
    //                             .sort((a, b) => new Date(b.joining_date) - new Date(a.joining_date))
    //                             .map((data, index) => {

    //                                 const formattedEndDate = new Date(data.joining_date).toLocaleString('en-US', {
    //                                     month: 'short',
    //                                     day: 'numeric',
    //                                     year: 'numeric',
    //                                 });


    //                                 return (
    //                                     <>
    //                                         <div key={index} className="dashcomp-bg-card dashcomp-bg-card-styling">
    //                                             <div className='new-flex'>
    //                                                 <CustomImageModal customStyle>
    //                                                     {data.profilepic ? (
    //                                                         <img
    //                                                             src={`${IMAGE_URL}${data.profilepic}`}
    //                                                             alt="profile" className='width-5vw image-radius'
    //                                                         />
    //                                                     ) : (
    //                                                         <UserDefaultLogo user={{ name: data.name, profilepic: data.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile-new-card'} />
    //                                                     )}
    //                                                 </CustomImageModal>

    //                                                 <div>
    //                                                     <h3 className='task-sub-heading  font-weight400  font-size-subheading  ' >Emp. Code: {data.emp_code}</h3>
    //                                                     <h3 className='dashcomp-announcement-heading font-weight500    font-size-subheading  ' >{data.name}</h3>
    //                                                 </div>
    //                                             </div>
    //                                             <span className="dashcomp-announcement-date  font-weight500   font-size-subheading  ">
    //                                                 <Calender />
    //                                                 {formattedEndDate}
    //                                             </span>
    //                                             <br />
    //                                             <div className='new-flex'>
    //                                                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                                                     <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    //                                                 </svg>
    //                                                 <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.division_name}</p>
    //                                             </div>
    //                                             <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.title}</p>
    //                                             <div className='new-flex'>
    //                                                 <div className='new-flex'>
    //                                                     <svg className='flex-shrink-0' width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                                                         <path d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    //                                                     </svg>
    //                                                     <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.designation_name}</p>
    //                                                 </div>
    //                                                 <div className='new-flex'>
    //                                                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //                                                         <path d="M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    //                                                     </svg>
    //                                                     <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.department_name}</p>
    //                                                 </div>
    //                                             </div>
    //                                         </div>

    //                                     </>
    //                                 );
    //                             })}
    //                     </div>}
    //         </div>
    //     </div>
    // )
    // }

    return (
        <div className="db2-card" style={{ position: 'relative' }}>



            {buffer ? (
                <Loader container={true} />
            ) : anniversary.length === 0 ? (
                <div className="db2-empty-state">
                    <div className="db2-empty-illus"> <UserProfileIcon color='rgb(37, 118, 188)' size={50} /></div>
                    <div className="db2-empty-title">No new joinings yet</div>
                </div>
            ) : (
                <>
                    <div className='employee-cards-container'>
                        {visibleEmployees.map((data, index) => {
                            const formattedDate = new Date(data.joining_date).toLocaleString('en-US', {
                                month: 'short', day: 'numeric', year: 'numeric',
                            });

                            return (
                                <div key={index}
                                    className="employee-card"
                                    style={{
                                        flex: 1,
                                        border: '1px solid #eef0f5',
                                        borderRadius: '12px',
                                        padding: '14px',
                                        position: 'relative',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '4px',
                                        background: '#f9fbff',
                                    }}>
                                    {/* Add person icon top-right */}
                                    <div style={{
                                        position: 'absolute', top: '12px', right: '12px',
                                        width: '28px', height: '28px', borderRadius: '20%',
                                        background: '#e3f0ff', display: 'flex',
                                        alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        {/* <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M12 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8zM19 8v6M22 11h-6" stroke="#2576BC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg> */}
                                        <AddEmployeeIcon wsize={22} hsize={16} />
                                    </div>

                                    {/* Profile pic */}
                                    {/* {data.profilepic ? ( */}
                                    <CustomImageModal customStyle>
                                        {data.profilepic ? (
                                            <img
                                                src={`${IMAGE_URL}${data.profilepic}`}
                                                alt="profile"
                                                style={{ width: '65px', height: '65px', borderRadius: '50%', objectFit: 'cover', marginBottom: '6px' }}
                                            />
                                        ) : (
                                            <UserDefaultLogo user={{ name: data.name, profilepic: data.profilepic }} customStyleforParent={"d-flex fill"} customStyleforChild={'emp-letter'} />
                                        )}
                                    </CustomImageModal>

                                    {/* ) : (
                                        <div style={{
                                            width: '56px', height: '56px', borderRadius: '50%',
                                            background: '#e8f0fe', display: 'flex',
                                            alignItems: 'center', justifyContent: 'center',
                                            fontWeight: 600, fontSize: '18px', color: 'rgb(37, 118, 188)',
                                            marginBottom: '6px'
                                        }}>
                                            {data.name?.charAt(0).toUpperCase()}
                                        </div>
                                    ) */}
                                    {/* } */}

                                    <div style={{ fontSize: '11px', color: '#94a3b8' }}>Emp. Code: {data.emp_code}</div>
                                    <div style={{ fontSize: '14px', fontWeight: 600, color: '#1e293b' }}>{data.name}</div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#64748b' }}>
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                            <rect x="3" y="4" width="18" height="18" rx="2" stroke="#555b63" strokeWidth="2" />
                                            <path d="M16 2v4M8 2v4M3 10h18" stroke="#555b63" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                        {formattedDate}
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '12px', color: '#64748b' }}>
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                            <path d="M3 21h18M9 21V7l6-4v18M9 12h6" stroke="#555b63" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        {data.division_name}
                                    </div>

                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px' }}>
                                        {data.designation_name && (
                                            <span style={{
                                                padding: '3px 8px', background: 'rgb(216 233 255)',
                                                color: 'rgb(37, 118, 188)', borderRadius: '6px',
                                                fontSize: '10px', fontWeight: 500,
                                                display: 'flex', alignItems: 'center', gap: '3px'
                                            }}>
                                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" stroke="rgb(10, 91, 161)" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                                {data.designation_name}
                                            </span>
                                        )}
                                        {data.department_name && (
                                            <span style={{
                                                padding: '3px 8px', background: 'rgb(216 233 255)',
                                                color: 'rgb(37, 118, 188)', borderRadius: '6px',
                                                fontSize: '10px', fontWeight: 500,
                                                display: 'flex', alignItems: 'center', gap: '3px'
                                            }}>
                                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                                    <path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM16 3H8a2 2 0 0 0-2 2v2h12V5a2 2 0 0 0-2-2z" stroke="rgb(10, 91, 161)" strokeWidth="2" strokeLinecap="round" />
                                                </svg>
                                                {data.department_name}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                        {visibleEmployees.length === 1 && <div style={{ flex: 1 }} />}
                    </div>


                    {/* Previous Arrow */}
                    {currentIndex > 0 && (
                        <button
                            onClick={handlePrev}
                            className="carousel-arrow carousel-arrow-prev"
                        >
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                <path d="M15 18l-6-6 6-6" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </button>
                    )}

                    {/* Next Arrow */}
                    {currentIndex < totalPages - 1 && (
                        <button
                            onClick={handleNext}
                            className="carousel-arrow carousel-arrow-next"
                        >
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M9 18l6-6-6-6"
                                    stroke="#64748b"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    )}

                    {/* Max 2 dots */}
                    {totalPages > 1 && (
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '12px' }}>
                            {getDotsConfig().map((pageIndex) => (
                                <div
                                    key={pageIndex}
                                    onClick={() => setCurrentIndex(pageIndex)}
                                    style={{
                                        width: '7px', height: '7px', borderRadius: '50%',
                                        background: pageIndex === currentIndex ? 'rgb(37, 118, 188)' : '#e2e8f0',
                                        cursor: 'pointer', transition: 'background 0.15s'
                                    }}
                                />
                            ))}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default NewEmployee;